module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ExChangeCouponListView.js"));
	}, "ExChangeCouponListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ExChangeCouponListView!./src/pages/PunchClock/Bean/ExChangeCouponList/ExChangeCouponListView.js
// module id = 1283
// module chunks = 431